import { request } from 'api/request';

import type { ERROR_DATA } from 'hooks/api/type';
import type { ProjectNames } from 'hooks/permission/types';

import { queryKeys } from 'utils/queryUtils';

import { QUERY_OPTIONS } from 'constants/queryConfig';

import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'store/AppProvider';

export interface SelectProjectsResponse {
    color: string;
    domain: string;
    id: number;
    name: string;
    system_name: ProjectNames;
    nuevo_id: string;
}

const apiRequest = async (): Promise<SelectProjectsResponse[]> => {
    return await request<SelectProjectsResponse[]>('admin/selects/projects');
};

export const useGetSelectProjects = (options: { retry?: number } = {}) => {
    const { appState } = useAppContext();
    const hasToken = Boolean(appState.user.user?.token);
    const retry = options.retry ?? QUERY_OPTIONS.REFERENCE_DATA.retry;

    return useQuery<SelectProjectsResponse[], ERROR_DATA<unknown>>({
        queryKey: queryKeys.projects,
        queryFn: async () => apiRequest(),
        enabled: hasToken, // do not fetch when logged out
        refetchOnMount: false,
        refetchOnReconnect: false,
        ...QUERY_OPTIONS.REFERENCE_DATA,
        retry,
    });
};
